var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("no-ssr", [
        _vm.token
          ? _c(
              "script",
              {
                attrs: {
                  type: "application/javascript",
                  id: "profitwell-js",
                  "data-pw-auth": _vm.token,
                  onload: _vm.startProfitwell
                }
              },
              [
                _vm._v(
                  "\n      (function (i, s, o, g, r, a, m) {\n        i[o] =\n          i[o] ||\n          function () {\n            (i[o].q = i[o].q || []).push(arguments);\n          };\n        a = s.createElement(g);\n        m = s.getElementsByTagName(g)[0];\n        a.async = 1;\n        a.src = r + '?auth=' + s.getElementById(o + '-js').getAttribute('data-pw-auth');\n        m.parentNode.insertBefore(a, m);\n      })(\n        window,\n        document,\n        'profitwell',\n        'script',\n        'https://public.profitwell.com/js/profitwell.js',\n      );\n    "
                )
              ]
            )
          : _vm._e()
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }